function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import React from "react";
import "./OfflineTask.css";
var OfflineTask = function OfflineTask() {
  return /*#__PURE__*/React.createElement("div", {
    className: "offline-task-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "offline-task-card-title"
  }, "Offline Task"), _toConsumableArray(new Array(20).keys()).map(function () {
    return /*#__PURE__*/React.createElement("div", {
      className: "offline-task-list"
    }, /*#__PURE__*/React.createElement("div", {
      className: "offline-task-data"
    }, /*#__PURE__*/React.createElement("span", {
      className: "offline-task-name"
    }, "Design Inspiration Board"), /*#__PURE__*/React.createElement("span", {
      className: "offline-task-time"
    }, "50 mins")), /*#__PURE__*/React.createElement("div", {
      className: "offline-task-user-data"
    }, /*#__PURE__*/React.createElement("div", {
      className: "offline-task-user-details"
    }, /*#__PURE__*/React.createElement("div", {
      className: "offline-task-user-details-avatar"
    }, "N"), /*#__PURE__*/React.createElement("span", {
      className: "offline-task-user-details-user-name"
    }, "Nandhini")), /*#__PURE__*/React.createElement("span", {
      className: "offline-task-time"
    }, "9.00 - 9.50")));
  }));
};
export default OfflineTask;